import SlidePro1 from '@assets/images/upgrade-carousel/pro/slide-1.png'
import SlidePro2 from '@assets/images/upgrade-carousel/pro/slide-2.png'
import SlidePro5 from '@assets/images/upgrade-carousel/pro/slide-5.png'
import SlidePro6 from '@assets/images/upgrade-carousel/pro/slide-6.png'
import SlidePro7 from '@assets/images/upgrade-carousel/pro/slide-7.png'
import SlidePro8 from '@assets/images/upgrade-carousel/pro/slide-8.png'
import SlidePro9 from '@assets/images/upgrade-carousel/pro/slide-9.png'
import Slide0 from '@assets/images/upgrade-carousel/team/slide-0.png'
import Slide1 from '@assets/images/upgrade-carousel/team/slide-1.png'
import Slide2 from '@assets/images/upgrade-carousel/team/slide-2.png'
import Slide3 from '@assets/images/upgrade-carousel/team/slide-3.png'
import Slide4 from '@assets/images/upgrade-carousel/team/slide-4.png'
import Slide5 from '@assets/images/upgrade-carousel/team/slide-5.png'
import Slide6 from '@assets/images/upgrade-carousel/team/slide-6.png'

import type { ProSlideType, TeamSlideType } from './types'

export const BUTTONS = [
  {
    label: 'Pro',
    value: 'pro',
  },
  {
    label: 'Team',
    value: 'team',
  },
]

export const ProSlideIndex: Record<ProSlideType, number> = {
  projects: 1,
  export: 2,
  seo: 3,
  templates: 4,
  symbol: 5,
  tags: 6,
  password_protect: 7,
  guest_comments: 8,
}

export const TeamSlideIndex: Record<TeamSlideType, number> = {
  projects: 1,
  comments: 2,
  members: 3,
  team: 4,
  support: 5,
  symbols: 6,
}

export const teamCarouselItems = [
  {
    img: Slide0,
    title: '',
    description: '',
  },
  {
    img: Slide1,
    title: 'Unlimited projects',
    description:
      'Have up to 8 active projects, with an archive\n to store older ones.',
  },
  {
    img: Slide2,
    title: 'Guest edit & comments',
    description:
      'Collaborate with clients without friction —\n just share a link.',
  },
  {
    img: Slide3,
    title: 'Members-only projects',
    description:
      'Advanced permissions, including\n member-only access for projects.',
  },
  {
    img: Slide4,
    title: 'Team space with folders',
    description:
      'Manage a dedicated team space with\n folders to organize all projects.',
  },
  {
    img: Slide5,
    title: 'Priority support',
    description:
      'Get an onboarding demo and priority\n email support from our product team.',
  },
  {
    img: Slide6,
    title: 'Shared symbol library',
    description:
      'One set of symbols reused across every\n project of the team.',
  },
]

export const proCarouselItems = [
  {
    img: Slide0,
    title: '',
    description: '',
  },
  {
    img: SlidePro1,
    title: 'Get more projects',
    description:
      'Have up to 8 active projects, with an archive\n to store older ones.',
  },
  {
    img: SlidePro2,
    title: 'Export anywhere',
    description: 'Enable PDF, PNG, Excel, and other export\n options.',
  },
  {
    img: SlidePro5,
    title: 'SEO & Analytics',
    description:
      'Edit SEO data and see Google Analytics\n numbers next to every page.',
  },
  {
    img: SlidePro6,
    title: 'Project templates',
    description: 'Save any project as a template and\n start new ones from it.',
  },
  {
    img: SlidePro7,
    title: 'Link blocks with symbols',
    description:
      'Work smarter with symbols - manage\n multiple blocks in one place.',
  },
  {
    img: SlidePro8,
    title: 'Add tags to track progress',
    description: 'Visualize the state of the project through\n custom tags.',
  },
  {
    img: SlidePro9,
    title: 'Password protect',
    description: 'Add an extra security layer to your project.',
  },
  {
    // The Team guest comment slide: until OCT-5395 the feature was Team-only.
    img: Slide2,
    title: 'Guest comments',
    description:
      'Clients comment from the link you send —\n no account needed.',
  },
]
